import { render } from "./ScheduleTestDrive.vue?vue&type=template&id=5d23be88&lang=true"
import script from "./ScheduleTestDrive.vue?vue&type=script&lang=js"
export * from "./ScheduleTestDrive.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__